import Vue from 'vue';
import Router from 'vue-router';
import VueSocketio from 'vue-socket.io';
import { io } from 'socket.io-client';

import AuthenticateToken from '../pages/responsive-pages/authenticated/AuthenticateToken.vue';
import InviteAuthenticateToken from '../pages/responsive-pages/invite-authenticated/InviteAuthenticateToken.vue';
import SuspiciousGroupJoinInvestigator from '../pages/responsive-pages/authenticated/suspicious-group-join/SuspiciousGroupJoinInvestigator.vue';
import CredentialsSettings from '../pages/responsive-pages/authenticated/navigation-pages/credentials-settings/CredentialsSettings.vue';
import AddCredentialsOnboarding from '../pages/responsive-pages/authenticated/onboard/steps/add-credentials/AddCredentialsOnboarding.vue';
import OnboardingFlow from '../pages/responsive-pages/authenticated/onboard/OnboardingFlow.vue';
import Onboard from '../pages/responsive-pages/authenticated/onboard/Onboard.vue';
import OnboardFlow from '../pages/responsive-pages/authenticated/onboard2/OnboardFlow.vue';
import CashflowApp from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/CashflowApp.vue';
import DemoCashflowApp from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/DemoCashflowApp.vue';
import BalancePage from '../pages/responsive-pages/authenticated/navigation-pages/balance/BalancePage.vue';
import CashflowTour from '../pages/responsive-pages/authenticated/cashflow-tour/CashflowAppTour.vue';
import SignupFlow from '../pages/responsive-pages/non-authenticated/wine-and-dine/signup/SignupFlow.vue';
import LeadQualificationSurvey from '../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/LeadQualificationFlow.vue';
import AccuracySurveyFlow from '../pages/responsive-pages/authenticated/survey/accuracy-survey/AccuracySurveyFlow.vue';
import TermsAndConditions from '../pages/terms-and-conditions/TermsAndConditions.vue';
import MemberInvite from '../pages/responsive-pages/invite-authenticated/member-invite/MemberInviteFlow.vue';
import ActivationSurvey from '../pages/responsive-pages/authenticated/survey/activation-survey/ActivationSurvey.vue';
import CSATSurvey from '../pages/responsive-pages/authenticated/survey/csat-survey/CSATSurvey.vue';
import Survey from '../pages/responsive-pages/authenticated/survey/Survey.vue';
import Playground from '../pages/base-ui-playground/Playground.vue';
import UnsupportedBanksMessagePage from '../pages/responsive-pages/authenticated/unsupported-banks/UnsupportedBanksMessagePage.vue';
import AppHeader from '../base-components/app-header/AppHeader.vue';
import ResponsivePage from '../pages/responsive-pages/ResponsivePage.vue';
import StateRouter from '../pages/responsive-pages/authenticated/routing/StateRouter.vue';
import DiscountLandingPage from '../pages/responsive-pages/non-authenticated/discount-api/DiscountLandingPage.vue';
import SubscriptionFlow from '../pages/responsive-pages/authenticated/subscription/SubscriptionFlow.vue';
import DiscountConnectionApprovedPage from '../pages/responsive-pages/non-authenticated/discount-api/DiscountConnectionApprovedPage.vue';
import PopupsManager from '../base-components/app-header/PopupsManager.vue';
import ChurnFlow from '../pages/responsive-pages/non-authenticated/churn/ChurnFlow.vue';
import AccountSettings from '../pages/responsive-pages/authenticated/navigation-pages/account-settings/AccountSettings.vue';
import LoginEnterPhoneNumber from '../pages/responsive-pages/non-authenticated/login/LoginEnterPhoneNumber.vue';
import LoginEnterCode from '../pages/responsive-pages/non-authenticated/login/LoginEnterCode.vue';
import LoginAs from '../pages/responsive-pages/non-authenticated/login/LoginAs.vue';
import store from '../store';
import config from '../config';
import Welcome from '../pages/responsive-pages/non-authenticated/wine-and-dine/Welcome.vue';
import FinishLQ from '../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/FinishLQ.vue';
import UnsupportedBankGoodbye from '../base-components/onboarding/UnsupportedBankGoodbye.vue';
import InviteMember from '../base-components/InviteMember.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/terms',
      name: 'TermsAndConditions',
      component: TermsAndConditions,
    },
    {
      path: '/internal/playground',
      name: 'Playground',
      component: Playground,
    },
    {
      path: '/',
      name: 'ResponsivePage',
      component: ResponsivePage,
      children: [
        {
          path: '/signup',
          name: 'welcome',
          component: Welcome,
          props: route => {
            if (route.query.refToken) {
              return { referralData: { householdName: route.query.hn, referralToken: route.query.refToken } };
            }
            return null;
          },
        },
        {
          path: '/signup/lq/vp/:componentName',
          name: 'LeadQualificationSurvey',
          component: LeadQualificationSurvey,
          props: route => {
            return { componentName: route.params.componentName, componentType: 'valueProp' };
          },
        },
        {
          path: '/signup/lq/finish',
          name: 'FinishLQ',
          component: FinishLQ,
        },
        {
          path: '/signup/lq/question/:componentName',
          name: 'LeadQualificationSurvey',
          component: LeadQualificationSurvey,
          props: route => {
            return { componentName: route.params.componentName, componentType: 'question' };
          },
        },
        {
          path: '/demo/',
          name: 'Demo',
          component: DemoCashflowApp,
        },
        {
          path: '/signup/details',
          name: 'Signup',
          component: SignupFlow,
        },
        {
          path: '/discount/welcome-back',
          name: 'DiscountLandingPage',
          component: DiscountLandingPage,
        },
        {
          path: '/s/token',
          name: 'DiscountConnectionApprovedPage',
          component: DiscountConnectionApprovedPage,
        },
        {
          path: '/goodbye',
          name: 'GoodbyePage',
          component: ChurnFlow,
        },
        {
          path: '/',
          name: 'InviteAuthenticateToken',
          component: InviteAuthenticateToken,
          children: [
            {
              path: 'invite',
              name: 'MemberInvite',
              component: MemberInvite,
            },
          ],
        },
        {
          path: '/internal/login-as',
          name: 'LoginAs',
          component: LoginAs,
        },
        {
          path: '/login',
          name: 'Login',
          component: LoginEnterPhoneNumber,
        },
        {
          path: '/login-enter-code',
          name: 'LoginEnterCode',
          component: LoginEnterCode,
        },
        {
          path: '/',
          name: 'AuthenticateToken',
          component: AuthenticateToken,
          redirect: { name: 'Home' },
          beforeEnter(to, from, next) {
            const { accessToken } = to.query;
            if (!Vue.prototype.$socket) {
              Vue.use(new VueSocketio({
                debug: false,
                connection: io(config.get().elsaPublicUrl, {
                  path: '/websockets',
                  transports: ['websocket', 'polling'],
                  reconnectionAttempts: 3,
                  auth: { accessToken },
                }),
                vuex: {
                  store,
                  mutationPrefix: 'socket_',
                },
              }));
            }
            next();
          },
          children: [
            {
              path: '/',
              name: 'AppHeader',
              component: AppHeader,
              redirect: { name: 'Home' },
              children: [
                {
                  path: '/',
                  name: 'PopupsManager',
                  component: PopupsManager,
                  redirect: { name: 'Home' },
                  props: route => {
                    return { hideCta: route.query.hideCta };
                  },
                  children: [
                    {
                      path: 'home',
                      name: 'Home',
                      component: CashflowApp,
                    },
                    {
                      path: 'cashflow-app',
                      name: 'CashflowApp',
                      component: CashflowApp,
                    }, {
                      path: 'balance',
                      name: 'BalancePage',
                      component: BalancePage,
                    }, {
                      path: 'credentials',
                      name: 'CredentialsSettings',
                      component: CredentialsSettings,
                    },
                    {
                      path: 'account-settings',
                      name: 'AccountSettings',
                      component: AccountSettings,
                    },
                  ],
                }],
            },
            {
              path: 'pre-cashflow',
              name: 'CashflowAppTour',
              component: CashflowTour,
            }, {
              path: 'sr',
              name: 'StateRouter',
              component: StateRouter,
            }, {
              path: 'group-join', // in app
              name: 'SuspiciousGroupJoinInvestigator',
              component: SuspiciousGroupJoinInvestigator,
            }, {
              path: '/onboard',
              name: 'Onboard',
              component: Onboard,
              children: [
                {
                  path: '',
                  name: 'Onboarding Preferences',
                  component: OnboardingFlow,
                }, {
                  path: 'add-credentials',
                  name: 'AddCredentialsOnboarding',
                  component: AddCredentialsOnboarding,
                },
              ],
            }, {
              path: '/invite-member',
              name: 'InviteMember',
              component: InviteMember,
            }, {
              path: 'unsupported-banks', // in app
              name: 'UnsupportedBanks',
              component: UnsupportedBanksMessagePage,
            }, {
              path: 'unsupported-bank', // in app
              name: 'UnsupportedBank',
              component: UnsupportedBankGoodbye,
              props: route => {
                return { sourceName: route.query.sourceName, sourceDisplayName: route.query.sourceDisplayName };
              },
            }, {
              path: 'subscription', // out of app
              name: 'subscription',
              component: SubscriptionFlow,
            }, {
              path: '/accuracy/:questionName',
              name: 'AccuracySurveyFlow',
              component: AccuracySurveyFlow,
              props: route => {
                return { questionName: route.params.questionName };
              },
            }, {
              path: 'survey',
              name: 'Survey',
              component: Survey,
              children: [
                {
                  path: 'first-cashflow', // in app
                  name: 'First Cashflow Survey',
                  component: ActivationSurvey,
                },
                {
                  path: 'csat', // in app
                  name: 'CSAT Survey',
                  component: CSATSurvey,
                },
              ],
            },
            {
              path: '/ob',
              name: 'Onboard',
              component: OnboardFlow,
            },
            {
              path: '*',
              redirect: { name: 'AuthenticateToken' },
            },
          ],
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js